import React, { FC } from 'react';
import styled from 'styled-components';
import { Link, PrimaryButton } from '../buttons';
import { T } from '../helpers/helpers';
import EmptyListIcon from '../icons/emptyListIcon.svg';
import MaterialIcon from '../leftAppSidebar/MaterialIcon';

const TopIcon = styled.div`
    margin: 20px 0px 20px 0 !important;
    transform: scale(0.8);
    transform-origin: center center;
`;

const EmptyListContainer = styled.div`
    display: grid;
    justify-items: center;
    padding-top: 60px;
    color: #263238;
`;
const Header = styled.h3`
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    padding-bottom: 8px;
    color: #263238;
`;

const SubHeader = styled.span`
    padding-bottom: 5px;
    white-space: pre-line;
    line-height: 20px;
    text-align: center;
    color: #263238;
    font-size: 13px;
`;

const LearnMoreContainer = styled.div`
    font-size: 13px;
`;

const Buttons = styled.div`
    display: flex;
    gap: 30px;
    justify-content: flex-end;
    margin-top: 30px;
`;

interface Props {
    title: string;
    subTitle: React.ReactNode;
    buttonTitle?: string;
    onButtonClick?: () => void;
    alreadyExistingButton?: React.ReactNode;
    icon?: React.ReactNode;
    hideIcon?: boolean;
    learnMoreText?: string;
    learnMoreLink?: string;
    disabledButton?: boolean;
}

export const EmptyList: FC<Props> = ({
    title,
    subTitle,
    buttonTitle,
    onButtonClick,
    alreadyExistingButton,
    learnMoreText,
    learnMoreLink,
    icon: iconLink,
    hideIcon = false,
    disabledButton = false
}) => {
    return (
        <>
            <EmptyListContainer>
                {!hideIcon &&
                    (iconLink ? (
                        <TopIcon>{iconLink}</TopIcon>
                    ) : (
                        <TopIcon>
                            <EmptyListIcon />
                        </TopIcon>
                    ))}
                <Header>{title}</Header>
                <SubHeader>{subTitle}</SubHeader>
                {learnMoreLink && (
                    <LearnMoreContainer>
                        <Link href={learnMoreLink} target={'_blank'}>
                            {learnMoreText ? learnMoreText : T._('Learn more', 'Admin')}
                        </Link>
                    </LearnMoreContainer>
                )}

                <Buttons>
                    {buttonTitle && onButtonClick && (
                        <PrimaryButton disabled={disabledButton} onClick={() => onButtonClick()}>
                            <MaterialIcon name='add' />
                            {buttonTitle}
                        </PrimaryButton>
                    )}
                    {alreadyExistingButton}
                </Buttons>
            </EmptyListContainer>
        </>
    );
};
